import ProjectionGridVue from './projection-grid.vue';
import GridContent from './renderer/grid-content.vue';

export default ProjectionGridVue;
export { GridContent };



// WEBPACK FOOTER //
// ./src/index.js